import { render } from "./EditChapter.vue?vue&type=template&id=3aaa3c3d"
import script from "./EditChapter.vue?vue&type=script&lang=js"
export * from "./EditChapter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__